<div class="dialog-title">
    <ng-content></ng-content>
</div>